import createVueApp from '@phoenix/createVueApp';
import ServicePriceCalculator from '@phoenix/components/ServicePriceCalculator.vue';

const app = createVueApp();
app.component('ServicePriceCalculator', ServicePriceCalculator);
app.mount('#phoenix-service-price-calculator');
